export const childsHerramientas = [
  {
    path: "convertidor",
    name: "admin-herramientas-convertidor",
    component: () =>
      import(
        /* webpackChunkName: "herramientas-convertidor" */ "@/modules/admin/pages/herramientas/Convertidor.vue"
      ),
  },
  {
    path: "grabaciones",
    name: "admin-herramientas-grabaciones",
    component: () =>
      import(
        /* webpackChunkName: "herramientas-grabaciones" */ "@/modules/admin/pages/herramientas/Grabaciones.vue"
      ),
  },
  {
    path: "meetings",
    name: "admin-herramientas-meetings",
    component: () =>
      import(
        /* webpackChunkName: "herramientas-meetings" */ "@/modules/admin/pages/herramientas/Meetings.vue"
      ),
  },
  {
    path: "notificaciones",
    name: "admin-herramientas-notificaciones",
    component: () =>
      import(
        /* webpackChunkName: "herramientas-notificaciones" */ "@/modules/admin/pages/herramientas/Notificaciones.vue"
      ),
  },
  {
    path: "ajustes-IA",
    name: "admin-herramientas-IA",
    component: () =>
      import(
        /* webpackChunkName: "herramientas-ia" */ "@/modules/admin/pages/herramientas/IA.vue"
      ),
  },
  {
    path: "ajustes-voice-IA",
    name: "admin-herramientas-voice-IA",
    component: () =>
      import(
        /* webpackChunkName: "herramientas-voice-ia" */ "@/modules/admin/pages/herramientas/VoiceIA.vue"
      ),
  },
  {
    path: "system-updates",
    name: "admin-herramientas-system-updates",
    component: () =>
      import(
        /* webpackChunkName: "herramientas-system-updates" */ "@/modules/admin/pages/herramientas/SystemUpdates.vue"
      ),
  },
];
